import request from '@/config/axios'

/** 动态状态：0=审核中 1=已发布 2=已屏蔽 */
export const MASTER_DYN_STATUS_OPTIONS: { label: string; value: number }[] = [
  { label: '审核中', value: 0 },
  { label: '已发布', value: 1 },
  { label: '已屏蔽', value: 2 }
]

export const MASTER_DYN_STATUS_LABELS: Record<number, string> = {
  0: '审核中',
  1: '已发布',
  2: '已屏蔽'
}

export const MASTER_DYN_STATUS_TAG_TYPES: Record<number, string> = {
  0: 'warning',
  1: 'success',
  2: 'danger'
}

/** 申诉状态：0=无 1=申诉中 2=申诉通过 3=申诉驳回 */
export const MASTER_DYN_APPEAL_LABELS: Record<number, string> = {
  0: '—',
  1: '申诉中',
  2: '申诉通过',
  3: '申诉驳回'
}

/** 师傅动态 VO（师傅要素与会员信息由后端填充） */
export interface MasterDynVo {
  id: number
  masterId: number
  masterName?: string
  masterCategory?: string
  memberNickname?: string
  memberAvatar?: string
  mobile?: string
  content: string
  status: number
  shieldReason?: string
  appealStatus: number
  appealRemark?: string
  likeCount: number
  auditTime?: Date
  createTime?: Date
}

/** 动态分页查询参数 */
export interface MasterDynPageParams {
  pageNo?: number
  pageSize?: number
  status?: number
  appealStatus?: number
  nickname?: string
  content?: string
}

export const MasterDynApi = {
  // 查询动态分页（状态/申诉状态/师傅姓名模糊/内容关键字）
  getDynPage: (params: MasterDynPageParams) => {
    return request.get({ url: '/xuanxue/master-dyn/page', params })
  },
  // 屏蔽已发布动态（原因必填，C 端即时下线）
  shieldDyn: (data: { id: number; reason: string }) => {
    return request.put({ url: '/xuanxue/master-dyn/shield', data })
  },
  // 审核动态（通过 → 已发布；驳回 → 已屏蔽）
  auditDyn: (data: { id: number; approved: boolean }) => {
    return request.put({ url: '/xuanxue/master-dyn/audit', data })
  },
  // 申诉复核（通过 → 恢复发布；驳回 → 维持屏蔽）
  reviewAppeal: (data: { id: number; approved: boolean; remark: string }) => {
    return request.put({ url: '/xuanxue/master-dyn/appeal-review', data })
  }
}
